import CustomFormGroup from "components/Atoms/CustomFormGroup"
import StaticSelector from "components/Atoms/StaticSelector"
import StringInput from "components/Atoms/StringInput"
import { GENDER_TYPES, EDUCATION_TYPES } from "data/static.items"
import React from "react"
import AllDCLocations from "../AllDCLocations"
import GoogleMapDialog from "../GoogleMapDialog"

const VendorUserDetails = ({ disableAddress = false }) => {
  return (
    <>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-3">
          <StringInput label="First Name" required path="firstName" />
        </div>
        <div className="col-span-3">
          <StringInput label="Last Name" required path="lastName" />
        </div>
        <div className="col-span-3">
          <StringInput
            label="Number"
            required
            path="number"
            helperText="Permanent number of the user"
          />
        </div>
        <div className="col-span-3">
          <StringInput
            label="Username"
            required
            path="username"
            helperText="A unique name given to the user"
          />
        </div>
      </div>
      <div className="grid grid-cols-12 gap-4 mt-3">
        <div className="col-span-3">
          <StringInput label="E-Mail" path="email" helperText="xyz@gmail.com" />
        </div>
        <div className="col-span-3">
          <StaticSelector
            big={true}
            path="gender"
            items={GENDER_TYPES}
            label="Gender"
          />
        </div>
        <div className="col-span-3">
          <StaticSelector
            big={true}
            path="education"
            items={EDUCATION_TYPES}
            label="Education"
          />
        </div>
        <div className="col-span-3">
          <CustomFormGroup big label="Address" required>
            <GoogleMapDialog
              btnProps={{
                fill: true,
                big: true,
              }}
              disabled={disableAddress}
              path="address"
            >
              <AllDCLocations />
            </GoogleMapDialog>
          </CustomFormGroup>
        </div>
      </div>
    </>
  )
}

export default VendorUserDetails
